import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { AxiosError } from "axios";

import { ITicket } from "../../../../interfaces";

import { EmitError } from "../../../../utils/EmitError";
import useAuth from "../../../../hooks/useAuth";
import TicketsService from "../../../../services/http/services/TicketsService";

interface IProps {
    id: number;
    giveawayId: number;
}

export default function useGiveawayTickets({ id, giveawayId}:  IProps) {
    const [tickets, setTickets] = useState<Array<ITicket>>([]);
    const [isLoading, setIsLoading] = useState<boolean>(false);

    const { activeCity } = useAuth();

    const navigate = useNavigate();

    useEffect(() => {
        const controller = new AbortController();

        async function loadData() {
            try {
                setIsLoading(true);

                const ticketsList =  await TicketsService.listTicketsByGiveawayIdAndAppUserId(
                        Number(giveawayId),
                        Number(id),
                        controller.signal,
                    );

                setTickets(ticketsList);

                setIsLoading(false);
            } catch (err) {
                if (err instanceof AxiosError && err.name === 'CanceledError') {
                    return;
                }

                EmitError(err, true, 'viewAppUserTickets_asodkaskldasd');
                setIsLoading(false);
            }
        }

        loadData();

        return () => {
            controller.abort();
        }
    }, [id, navigate, giveawayId, activeCity]);

    return {
        tickets,
        isLoading,
    }
}
